import React from 'react'
import { Modal, Button } from 'antd'
import './style.css'
import IntlMessages from 'util/IntlMessages'
import { SwapOutlined } from '@ant-design/icons'

const WebsiteModal = ({ visible, setVisible }) => {
	const handleOk = () => {
		setVisible(false)
		localStorage.setItem('websiteModalShown', 'true')
		localStorage.setItem('newSiteLinkClicked', 'true')
	}

	const handleCancel = () => {
		setVisible(false)
		localStorage.setItem('websiteModalShown', 'true')
	}

	const token = localStorage.getItem('userKey')
	const newWebsiteUrl = process.env.REACT_APP_NEW_SITE_URL

	return (
		<Modal
			open={visible}
			onOk={handleOk}
			onCancel={handleCancel}
			width={860}
			zIndex={10001}
			className='website-promo-modal'
			footer={[
				<div className='custom-footer'>
					<p style={{ margin: 0, color: 'primary' }}>
						<span
							role='img'
							aria-label='warning'
							style={{ marginRight: '8px' }}
						>
							⚠️
						</span>
						<IntlMessages id='new.site.modal.warning' />
					</p>
				</div>
			]}
		>
			<div className='modal-content-wrapper'>
				{/* Modal content */}
				<div className='modal-body'>
					<div className='modal-icon'>
						<span role='img' aria-label='celebration'>
							🎉
						</span>
					</div>

					<h2 className='modal-title'>
						<IntlMessages id='new.site.modal.title' />
					</h2>

					<p className='modal-description'>
						<IntlMessages id='new.site.modal.desc' />
					</p>

					<p className='modal-note'>
						<IntlMessages id='new.site.modal.note' />
					</p>

					<Button
						type='primary'
						size='large'
						className='modal-primary-btn'
						onClick={() => {
							// Add navigation to new website or specific action
							window.open(
								`${newWebsiteUrl}/user/from-old-site/${
									token ? token : 'not-signed-in'
								}`,
								'_blank'
							)
							handleOk()
						}}
					>
						<span role='img' aria-label='link' style={{ marginRight: '8px' }}>
							<SwapOutlined />
						</span>
						<IntlMessages id='new.site.modal.button' />
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default WebsiteModal
